import React, { useContext, useEffect, useState } from 'react'
import "../Pages/Style/dashboard.css";
import "../../App.css";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import LogoutCard from '../Components/Card/LogoutCard';
import Footer from '../Components/Footer/Footer';
import SideBar from '../Components/SideBar/SideBar';
import TextLinkExample from '../Components/NavBar/NavBar';
import { SidebarContext } from '../../context/SidebarContext';
import { useDashboardDataQuery, useProfileQuery } from '../../redux/API/FM/FMDashboardApi';
import { formatIndianNumber } from '../../Constant/utils';
import DoughnutChart from '../Components/Card/DoughnutChart';
import BarChart from '../Components/Card/BarChart';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const FranchiseDashboard = () => {
const { isSiderbaropen } = useContext(SidebarContext);
const [showLogout, setShowLogout] = useState(false);
const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [doughnutChartData, setDoughnutChartData] = useState({ labels: [], datasets: [] });
 const getProfile = useProfileQuery()
 const userData = JSON.parse(localStorage.getItem("userData"));
 const cpId = userData?.validateEmail && userData?.validateEmail[0]?._id;
const {data, isLoading} = useDashboardDataQuery(cpId)
 const [profileData, setProfileData] = useState("")
   
   useEffect(() => {
     if (getProfile.isSuccess && !getProfile.isError && !getProfile.isLoading) {
       setProfileData(getProfile?.data)
       
     }
   }, [getProfile]);

   useEffect(() => {
         if (data?.newdata) {
           const currentValue = data?.newdata?.reduce((acc, result) => {
             const currentprice = result?.stocklist?.currentprice;
             return acc + (currentprice ? currentprice * result.qty : 0);
           }, 0);
             
             
           // Calculate the percentage of each industry in currentValue
           const industryPercentages = data?.newdata?.reduce((acc, result) => {
             const industry = result?.stocklist?.industry;
             const currentprice = result?.stocklist?.currentprice;
             const value = currentprice ? currentprice * result.qty : 0;
            
             if (industry) {
               if (!acc[industry]) {
                 acc[industry] = 0;
               }
               acc[industry] += value;
             }
     
             return acc;
           }, {});
     
           // Convert industryPercentages to an array and calculate the percentage
           const industryArray = Object.keys(industryPercentages).map(
             (industry) => ({
               industry,
               percentage: Math.round((industryPercentages[industry] / currentValue) * 100),
             })
           );
     
           // Sort by currentprice and take the top 10
           const top10Industries = industryArray
             .sort((a, b) => b.percentage - a.percentage)
             .slice(0, 10);
     
           // Prepare data for the chart
           const labels = top10Industries.map((item) => item.industry);
           const percentages = top10Industries.map((item) => item.percentage);
        
           // Set chart data
           setChartData({
             labels: labels,
             datasets: [
               {
                 label: "Weightage of Current Value",
                 data: percentages,
                 backgroundColor: "rgb(109, 214, 214)",
                 borderColor: "rgb(109, 214, 214)",
                 borderWidth: 1,
                 barThickness: 25,
                 maxBarThickness: 30, 
               },
             ],
           });
         }
       }, [data]);
     
       useEffect(() => {
         if (data?.newdata) {
           // Count the number of large cap and small cap stocks
           const capCount = data?.newdata?.reduce((acc, result) => {
             const marketCap = result?.stocklist?.marketcapital;
             if (marketCap) {
               if (!acc[marketCap]) {
                 acc[marketCap] = 0;
               }
               acc[marketCap] += 1;
             }
             return acc;
           }, {});
     
           // Calculate total count
           const totalCount = Object.values(capCount).reduce((acc, count) => acc + count, 0);
     
           // Calculate percentage
           const capPercentages = Object.keys(capCount).map(cap => ({
             label: `${cap} ${Math.round((capCount[cap] / totalCount) * 100)}%`,
             percentage: (capCount[cap] / totalCount) * 100,
           }));
     
           // Prepare data for the doughnut chart
           const labels = capPercentages.map(item => item.label);
           const percentages = capPercentages.map(item => item.percentage);
     
           // Set chart data
           setDoughnutChartData({
             labels: labels,
             datasets: [{
               data: percentages,
               backgroundColor: [
                 '#ea7e90', 
                 '#a84926',
                 '#e28743'
               ],
               hoverOffset: 4
             }]
           });
         }
       }, [data]);
  

  return (
   <>
   <div className="App">
        <SideBar />
        <div className={!isSiderbaropen ? "pages" : "pages-change"}>
          <TextLinkExample setShowLogout={setShowLogout} />
          <div className="HomeCard">
          <div className="col-md mx-4">
              <div className="row ">
                <div className="col-xl-4 col-md-6 px-lg-1">
                  <div className="card static-1 row-1" style={{borderBottom: "14px solid #5A4343"}}>
                    <div className="mx-4">
                      <h5 className="card-title">Current Portfolio Value</h5>
                      <h2 className="Values">
                        {
                       isLoading ? "Loading..." :  `Rs. ${formatIndianNumber(data?.data[0]?.totalHoldingValue)}`
                       
                       }
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6  px-lg-1">
                  <div className="card static-2 row-1" style={{borderBottom: "14px solid #5A4343"}}>
                    <div className="mx-4">
                      <h5 className="card-title">Total Fund Invested</h5>
                      <h2 className="Values">
                    
                      {
                       isLoading ? "Loading..." :  `Rs. ${formatIndianNumber(data?.data[0]?.totalfundinvested)}`
                       
                       }
                        </h2>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6  px-lg-1">
                  <div className="card static-3 row-1" style={{borderBottom: "14px solid #5A4343"}}>
                    <div className="mx-4">
                      <h5 className="card-title">No. of Clients</h5>
                      <h2 className="Values">
                      {
                       isLoading ? "Loading..." :  `${data?.data[0]?.numberofclient}`
                       
                       }
                      
                       </h2>
                    </div>
                  </div>
                </div>
               
                <div className="col-xl-4 col-md-6 px-lg-1 pe-lg-0 ">
                  <div className="card static-4 " style={{borderBottom: "14px solid #5A4343"}}>
                    <div className="mx-4">
                      <h5 className="card-title">Absolute Return</h5>
                      <h2 className="Values">
                      
                      {
                       isLoading ? "Loading..." :  `${Math.round(data?.data[0]?.absreturn)}%`
                       
                       }
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 px-lg-1">
                  <div className="card static-1 " style={{borderBottom: "14px solid #5A4343"}}>
                    <div className="mx-4">
                      <h5 className="card-title">Number of Channel Partners</h5>
                      <h2 className="Values">
                      {
                       isLoading ? "Loading..." :  `${Math.round(data?.data[0]?.cplist)}`
                       
                       }
                      
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="PieChart-Table row gy-3 mx-4 mt-4">
              <div className=" PieChart col-lg-12">
                <div className="row gy-3">
                  <div className="PieChartTitle d-flex m-2">
                    <h5>PortFolio Strategy: </h5>
                    <h5
                    className='mt-3'
                      style={{
                        backgroundColor: "#9DC913",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        color: "white",
                      }}
                    >
                      {" "}
                      E-50 Strategy{" "}
                    </h5>
                  </div>
                  <div className="col-md-5">
                   <div style={{height: "300px"}}>
                   <DoughnutChart
                    doughnutChartData={doughnutChartData}
                    />
                   </div>
                  </div>
                  <div className="col-md-7 px-lg-1">
                    <BarChart chartData={chartData} />
                  </div>
                  <div
                    className="PieChartFooter mt-4"
                    style={{
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "#78766f",
                    }}
                  >
                    <div className="text-white py-1" style={{backgroundColor: "#9DC913"}}>
                      No. of Stocks in Portfolio:{" "}
                     
                        <strong>30</strong>
                     
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <Footer/>
          </div>
          </div>
          {showLogout && <LogoutCard setShowLogout={setShowLogout} />}
   </>
  )
}

export default FranchiseDashboard